// import { FIND_USER } from "../../routes";
import customAxios from "../../customAxios";
import { IFindUserInformation } from "../../../types/common.interface";
import utils from "../../../utils";
import { FIND_USER } from "../../routes";
import {
  ICreateAndUpdateCompany,
  IRequestCompany,
} from "../../../types/company.interface";

async function getAllCompany(props: IRequestCompany) {
  var thisUrl = FIND_USER + "?";

  const populateFields = "cities municipality";

  // thisUrl += `&populate=${populateFields}`;

  let body: any = {
    page: props?.page,
    limit: props?.limit,
    role: "COMPANY",
    populate: populateFields,
  };

  // ?? ---------------------------------------------------------------------------------------------------------------------
  // ?? =====================================================================================================================
  // ??                                            Searching For SuperAgent
  // ?? =====================================================================================================================
  // ?? ---------------------------------------------------------------------------------------------------------------------

  if (props?.search?.value) {
    body = {
      ...body,
      search: {
        searchMode: props?.search?.base,
        searchValue: props?.search?.value,
      },
    };
  }

  // ?? ---------------------------------------------------------------------------------------------------------------------
  // ?? =====================================================================================================================
  // ??                                                    Filtering For SuperAgent
  // ?? =====================================================================================================================
  // ?? ---------------------------------------------------------------------------------------------------------------------
  if (props?.filters) {
    const { municipality } = props.filters;
    body = {
      ...body,
      municipality: (municipality as ICreateAndUpdateCompany)?._id,
    };
  }

  //   // if }}(province) query({ target: "province", value: province?._id });
  //   // if (city) query({ target: "city", value: city?._id });
  //   // if (superAgent) query({ target: "superAgent", value: superAgent?._id });
  // }

  // !! ---------------------------------------------------------------------------------------------------------------------
  // !! =====================================================================================================================
  // !!                                            Try Catch For SuperAgent
  // !! =====================================================================================================================
  // !! ---------------------------------------------------------------------------------------------------------------------

  try {
    return (await customAxios.post(thisUrl, body)).data;
  } catch (error: any) {
    console.error({ GET_ALL_COMPANY: error });
  }
}

export default getAllCompany;
